import React from 'react';
import { setAction, resendInvitationAction } from '../actions/teamInvitationsPage';
import store from '../../../redux/store';
import { createSelector } from 'reselect';

const getRawInvites = (state) => state.teamInvitationsPage.invitations || [];
const getTeam = (state) => state.profile.team || {};

export const getInvites = createSelector(getRawInvites, getTeam, (invites, team) =>
  invites.map((invitation) => {
    function resend() {
      store.dispatch(resendInvitationAction({ team, invitation }));
    }
    function cancelInvite() {
      store.dispatch(
        setAction({
          showCancelInvitation: true,
          inviteId: invitation.id,
        })
      );
    }
    invitation.resend = (
      <div className="rowActions" onClick={resend}>
        <span className="bulk-action-btn secondary-btn">Resend</span>
      </div>
    );
    invitation.delete = (
      <div className="rowActions" onClick={cancelInvite}>
        <span className="bulk-action-btn secondary-btn negative">Delete</span>
      </div>
    );
    return invitation;
  })
);
